import React, { useContext, useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import MenuIcon from "../../components/icons/MenuIcon";
import { useTheme } from "@mui/material/styles";
import {
  Avatar,
  Box,
  Button,
  Grid,
  IconButton,
  Paper,
  Skeleton,
  TextField,
  Typography,
  Card,
  CardContent,
  Chip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { Link } from "react-router-dom";
import makeStyles from "@mui/styles/makeStyles";
import ListIcon from "../../components/icons/ListIcon";
import FilterIcon from "../../components/icons/FilterIcon";
import { getDataWithToken } from "../../services/GetDataService";
import { AuthContext } from "../../context/AuthContext";
import moment from "moment";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import UserDetails from "./UserDetails";
import CloseIcon from "@mui/icons-material/Close";
import InfiniteScroll from "react-infinite-scroll-component";
import PulseLoader from "react-spinners/PulseLoader";
import CountryList3DigitCode from "../CountryList3DigitCode";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import SearchIcon from "@mui/icons-material/Search";
import { 
  Business as BusinessIcon,
  SwapHoriz as SwapIcon,
  Check as CheckIcon
} from "@mui/icons-material";
const useStyles = makeStyles((theme) => ({}));

const UserList = () => {
  const theme = useTheme();
  const classes = useStyles();
  const { login, admin_panel_user, logout } = useContext(AuthContext);
  const [userList, setUserList] = useState([]);
  const [userLoading, setUserLoading] = useState(false);
  const [userMessage, setUserMessage] = useState("");
  const [totalData, setTotalData] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [open, setOpen] = useState(false);
  const [userId, setUserId] = useState("");
  const [refresh, setRefresh] = useState(false);
  const [filterUserId, setFilterUserId] = useState("");
  const [filterIdType, setFilterIdType] = useState("");
  const [filterId, setFilterId] = useState("");
  const [filterCountry, setFilterCountry] = useState("");
  const [filterVerified, setFilterVerified] = useState("");
  const [userDocumentNoLabel, setUserDocumentNoLabel] = useState("");
  const [storeList, setStoreList] = useState([]);
  const [selectedStoreId, setSelectedStoreId] = useState(null);
  const [selectedProject, setSelectedProject] = useState(null);
  const [hasStores, setHasStores] = useState(true);
  const handleClickOpen = (id) => {
    setUserId(id);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleProjectChange = (event) => {
    const projectId = event.target.value;
    const project = storeList.find(store => store.id === projectId);
    if (project) {
      setSelectedProject(project);
      setSelectedStoreId(projectId);
      // Update the admin_panel_user context with selected store ID
      admin_panel_user.selectedStoreId = projectId;
    }
  };

  const loadStores = async () => {
    try {
      let stores = await getDataWithToken(
        "getStoreInformation",
        admin_panel_user,
        logout
      );

      if (stores?.data?.code === 200) {
        if (stores.data?.data?.storeInfo?.length > 0) {
          setStoreList(stores.data.data.storeInfo);
          // Select the first store
          const firstStore = stores.data.data.storeInfo[0];
          setSelectedStoreId(firstStore.id);
          setSelectedProject(firstStore);
          setHasStores(true);
          // Update the admin_panel_user context
          admin_panel_user.selectedStoreId = firstStore.id;
        } else {
          setStoreList([]);
          setSelectedStoreId(null);
          setSelectedProject(null);
          setHasStores(false);
        }
      } else if (stores?.data?.code === 404) {
        setStoreList([]);
        setSelectedStoreId(null);
        setSelectedProject(null);
        setHasStores(false);
      } else {
        setStoreList([]);
        setSelectedStoreId(null);
        setSelectedProject(null);
        setHasStores(false);
      }
    } catch (error) {
      console.error("Error loading stores:", error);
      setStoreList([]);
      setSelectedStoreId(null);
      setSelectedProject(null);
      setHasStores(false);
    }
  };

  const pageLoading = () => {
    let rows = [];

    for (let i = 0; i < 25; i++) {
      let cells = [];

      for (let j = 0; j < 8; j++) {
        cells.push(
          <TableCell key={j} sx={{ py: 1.5 }}>
            <Skeleton></Skeleton>
          </TableCell>
        );
      }

      rows.push(<TableRow key={i}>{cells}</TableRow>);
    }

    return rows;
  };
  const handleChangePage = (event, newPage) => {
    // setPage(newPage);

    let pageNo = newPage + 1;
    getData(pageNo);
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 50));
    setPage(0);
  };
  const getData = async (pageNO, newUrl) => {
    setUserLoading(true);
    // setUserList([]);
    setUserMessage("");
    let newPageNO;
    let url;
    if (pageNO) {
      newPageNO = pageNO;
    } else {
      newPageNO = 1;
    }
    if (newUrl) {
      url = newUrl;
    } else {
      let newIdType = filterIdType;
      let newCountry = filterCountry;
      let newVerified = filterVerified;
      let newId = filterId;
      if (filterIdType === "None") {
        newIdType = "";
      }
      if (filterCountry === "None") {
        newCountry = "";
      }
      if (filterVerified === "None") {
        newVerified = "";
      }
      if (!showIdField()) {
        newId = "";
      }
      url = `getUsersList?storeId=${admin_panel_user.selectedStoreId}&userId=${filterUserId}&idType=${newIdType}&id=${newId}&country=${newCountry}&verified=${newVerified}&pageNumber=${newPageNO}`;
    }

    let users = await getDataWithToken(url, admin_panel_user, logout);

    if (users.data.status) {
      setTotalData(users.data.data.totalDocument);
      if (users.data.data.userList.length > 0) {
        setUserList(users.data.data.userList);
      } else {
        setUserMessage(users.data.message);
        setUserList([]);
      }
    } else {
      setUserMessage(users.data.message);
    }
    setUserLoading(false);
  };

  const getDataOnScrolling = async (pageNO) => {
    if (userLoading) return;

    let previousData = userList;
    let newPageNO = page + 1;
    setPage(newPageNO);

    let users = await getDataWithToken(
      `getUsersList?storeId=${admin_panel_user.selectedStoreId}&pageNumber=${newPageNO}`,
      admin_panel_user,
      logout
    );
    if (users.data.status) {
      console.log("users.data.data", users.data.data.userList);
      if (users.data.data.userList.length > 0) {
        let alldata = Array.prototype.push.apply(
          previousData,
          users.data.data.userList
        );

        setUserList(previousData);
        setTotalData(users.data.data.totalDocument);
        setRefresh(!refresh);
      } else {
        setUserMessage(users.data.message);
      }
    } else {
      setUserMessage(users.data.message);
    }
  };
  const clearFilter = () => {
    setFilterUserId("");
    setFilterId("");
    setFilterIdType("");
    setFilterCountry("");
    setFilterVerified("");
    setPage(1);
    let newUrl = `getUsersList?storeId=${admin_panel_user.selectedStoreId}&pageNumber=1`;
    getData("", newUrl);
  };
  const handleFilterId = (e) => {
    // if (filterIdType.length < 1 || filterIdType === "None") {

    // }else{

    //   setFilterId(e.target.value);
    // }
    setFilterId(e.target.value);
  };
  const handleFilterIdType = (e) => {
    setFilterIdType(e.target.value);
    switch (e.target.value) {
      case "NID":
        setUserDocumentNoLabel("NID No");
        break;
      case "oldNid":
        setUserDocumentNoLabel("Old NID No");
        break;
      case "Passport":
        setUserDocumentNoLabel("Passport No");
        break;
      case "Residence permit":
        setUserDocumentNoLabel("Residence Permit No");
        break;
      case "NID":
        setUserDocumentNoLabel("NID");
        break;
      case "Driving Licence":
        setUserDocumentNoLabel("Driving Licence No");
        break;

      default:
        break;
    }
  };
  const showIdField = () => {
    if (filterIdType.length < 1 || filterIdType === "None") {
      return false;
    } else {
      return true;
    }
  };
  const showStatusText = (row) => {
    if (row?.selfie_image?.selfie_image_link) {
      return (
        <TableCell
          sx={{
            color: `${theme.palette.success.main}`,
            fontWeight: 500,
          }}
        >
          Verified
        </TableCell>
      );
    } else if (row?.fail_photo_matching?.length === 5) {
      return (
        <TableCell
          sx={{
            color: `${theme.palette.error.main}`,
            fontWeight: 500,
          }}
        >
          Not Verified
        </TableCell>
      );
    } else if (
      row?.selfie_image?.selfie_image_link === undefined &&
      (row?.fail_photo_matching === undefined ||
        row?.fail_photo_matching?.length < 5)
    ) {
      return (
        <TableCell
          sx={{
            color: `${theme.palette.info.main}`,
            fontWeight: 500,
          }}
        >
          Partially Complete
        </TableCell>
      );
    } else {
      return <TableCell>-----</TableCell>;
    }
  };
  useEffect(() => {
    loadStores();
  }, []);

  useEffect(() => {
    if (selectedStoreId) {
      getData();
    }
  }, [selectedStoreId]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <div>
      {/* Current Project Card */}
      {hasStores && selectedProject && (
        <Card sx={{ 
          backgroundColor: "#fff",
          boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.05)",
          borderRadius: "15px",
          border: "1px solid #E5FFFD",
          marginBottom: "1.5rem"
        }}>
          <CardContent>
            <Grid container alignItems="center" justifyContent="space-between">
              <Grid item xs={12} md={8}>
                <Box sx={{ display: "flex", alignItems: "center", gap: "0.75rem" }}>
                  <Avatar sx={{ 
                    backgroundColor: "#E5FFFD", 
                    color: "#016363", 
                    width: "50px", 
                    height: "50px" 
                  }}>
                    <BusinessIcon />
                  </Avatar>
                  <Box>
                    <Typography variant="h6" sx={{ 
                      color: "#016363", 
                      fontWeight: 600,
                      marginBottom: "0.25rem"
                    }}>
                      {selectedProject.storeName}
                    </Typography>
                    <Typography variant="body2" sx={{ 
                      color: "#666",
                      marginBottom: "0.5rem"
                    }}>
                      {selectedProject.storeDesc || "No description provided"}
                    </Typography>
                    <Box sx={{ display: "flex", gap: "0.5rem", flexWrap: "wrap" }}>
                      <Chip
                        label={`ID: ${selectedProject.id.slice(-8)}`}
                        size="small"
                        sx={{
                          backgroundColor: "#E5FFFD",
                          color: "#016363",
                          fontWeight: 500,
                          fontSize: "0.75rem"
                        }}
                      />
                      <Chip
                        label={`Created: ${moment(selectedProject.storeCreated).format("DD MMM YYYY")}`}
                        size="small"
                        sx={{
                          backgroundColor: "#E5FFFD",
                          color: "#016363",
                          fontWeight: 500,
                          fontSize: "0.75rem"
                        }}
                      />
                      <Chip
                        label="Active"
                        size="small"
                        sx={{
                          backgroundColor: "#E8F5E8",
                          color: "#2E7D32",
                          fontWeight: 500,
                          fontSize: "0.75rem"
                        }}
                      />
                    </Box>
                  </Box>
                </Box>
              </Grid>
              
              {storeList.length > 1 && (
                <Grid item xs={12} md={4}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                    <SwapIcon sx={{ color: "#016363", fontSize: "1.25rem" }} />
                    <FormControl sx={{ minWidth: 200 }} size="small">
                      <InputLabel id="project-switch-label">
                        Switch Project
                      </InputLabel>
                      <Select
                        labelId="project-switch-label"
                        id="project-switch"
                        value={selectedStoreId || ""}
                        label="Switch Project"
                        onChange={handleProjectChange}
                        sx={{
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#E5FFFD",
                          },
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#016363",
                          },
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#016363",
                          },
                        }}
                      >
                        {storeList.map((project) => (
                          <MenuItem key={project.id} value={project.id}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                              {project.id === selectedStoreId && (
                                <CheckIcon sx={{ fontSize: "1rem", color: "#016363" }} />
                              )}
                              <Typography variant="body2">
                                {project.storeName}
                              </Typography>
                            </Box>
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                </Grid>
              )}
            </Grid>
          </CardContent>
        </Card>
      )}

      {!hasStores ? (
        <Paper sx={{ p: 4, textAlign: "center", marginBottom: "1.5rem" }}>
          <Typography variant="h5" sx={{ color: "#016363", marginBottom: "1rem" }}>
            No Projects Available
          </Typography>
          <Typography variant="body1" sx={{ color: "#666", marginBottom: "2rem" }}>
            You don't have any projects yet. Create your first project to get started with E-KYC profiles.
          </Typography>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#016363",
              color: "white",
              "&:hover": {
                backgroundColor: "#014a4a",
              },
            }}
            onClick={() => window.location.href = "/projects"}
          >
            Go to Projects
          </Button>
        </Paper>
      ) : (
        <>
          <Paper sx={{ py: 1, px: 3, mb: 3 }}>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item xs="auto">
            <Grid container alignItems="center" spacing={1}>
              <Grid item xs="auto">
                {" "}
                <Avatar
                  sx={{
                    width: 44,
                    height: 44,
                    bgcolor: `${theme.palette.primary.light}`,
                  }}
                >
                  <ListIcon color={theme.palette.primary.main} />
                </Avatar>
              </Grid>
              <Grid item xs="auto">
                <Typography
                  variant="base"
                  color="text.main"
                  sx={{ fontWeight: 500 }}
                >
                  E-KYC Profile List
                </Typography>

                {/* <Breadcrumbs
                  aria-label="breadcrumb"
                  // className={classes.breadcrumbsStyle}
                >
                  <Link to="/dashboard">Dashboard</Link>

                  <Link to="#">List of Users</Link>
                </Breadcrumbs> */}
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs="auto">
            <Breadcrumbs
              aria-label="breadcrumb"
              // className={classes.breadcrumbsStyle}
            >
              <Link to="/dashboard">Dashboard</Link>

              <Link to="#">List of Users</Link>
            </Breadcrumbs>
          </Grid>
        </Grid>
      </Paper>
      <Paper sx={{ p: 3, pb: 0 }}>
        <Grid container alignItems="flex-start" spacing={1}>
          <Grid item xs={2}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="User ID"
              variant="outlined"
              size="small"
              className="xs_input"
              value={filterUserId}
              onChange={(e) => setFilterUserId(e.target.value)}
            />
          </Grid>

          <Grid item xs={2}>
            <TextField
              id="outlined-select-currency"
              size="small"
              fullWidth
              select
              label="Select Document Type"
              // defaultValue="EUR"
              variant="outlined"
              className="xs_select"
              value={filterIdType}
              onChange={handleFilterIdType}
            >
              {" "}
              <MenuItem value={"None"}>None</MenuItem>
              <MenuItem value={"NID"}>NID</MenuItem>
              <MenuItem value={"oldNid"}>Old NID</MenuItem>
              <MenuItem value={"Passport"}>Passport</MenuItem>
              <MenuItem value={"Residence permit"}>Residence Permit</MenuItem>
              <MenuItem value={"Driving Licence"}>Driving Licence</MenuItem>
            </TextField>
          </Grid>
          {showIdField() && (
            <Grid item xs={2}>
              <TextField
                fullWidth
                // disabled={filterIdType.length < 1 || filterIdType === "None"}
                // placeholder="please select a Document Type"
                id="outlined-basic"
                // label={
                //   filterIdType.length < 1 || filterIdType === "None"
                //     ? "Please select a Document Type"
                //     : "ID"
                // }
                label={userDocumentNoLabel}
                variant="outlined"
                size="small"
                className="xs_input"
                value={filterId}
                onChange={handleFilterId}
              />
              {/* <Typography variant="xsmall" color="text.main">
              Please select a Document Type to enable this field
            </Typography> */}
            </Grid>
          )}

          <Grid item xs={2}>
            <TextField
              id="outlined-select-currency"
              size="small"
              fullWidth
              select
              label="Select Country"
              // defaultValue="EUR"
              variant="outlined"
              className="xs_select"
              value={filterCountry}
              onChange={(e) => setFilterCountry(e.target.value)}
            >
              {" "}
              <MenuItem value={"None"}>None</MenuItem>
              {CountryList3DigitCode.map((option) => (
                <MenuItem key={option.name} value={option.code}>
                  {option.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={2}>
            <TextField
              id="outlined-select-currency"
              size="small"
              className="xs_select"
              fullWidth
              select
              label="Select Status"
              // defaultValue="EUR"
              variant="outlined"
              value={filterVerified}
              onChange={(e) => setFilterVerified(e.target.value)}
            >
              <MenuItem value={"None"}>None</MenuItem>
              <MenuItem value={true}>Verified</MenuItem>
              <MenuItem value={"partiallyVerified"}>
                Partially Verified
              </MenuItem>
              <MenuItem value={false}>Not Verified</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={2}>
            <Grid container spacing={1}>
              <Grid item xs={4}>
                <Button
                  variant="outlined"
                  disableElevation
                  size="small"
                  color="info"
                  fullWidth
                  onClick={clearFilter}
                >
                  <RestartAltIcon />
                </Button>
              </Grid>

              <Grid item xs={8}>
                <Button
                  variant="contained"
                  disableElevation
                  color="primary"
                  // style={{ background: "#022424" }}
                  size="small"
                  startIcon={<SearchIcon />}
                  fullWidth
                  onClick={(event) => handleChangePage(event, 0)}
                >
                  Search
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <br />
        <TableContainer
          id="user-list-holder"
          sx={{ maxHeight: "calc(100vh - 450px)" }}
        >
          {/* <InfiniteScroll
            scrollableTarget="user-list-holder"
            dataLength={userList.length}
            next={getDataOnScrolling}
            // hasMore={continueNext}
            hasMore={userList.length !== totalData}
            scrollThreshold={0.95}
            loader={
              <PulseLoader
                color={theme.palette.primary.main}
                loading={true}
                size={15}
                speedMultiplier={0.5}
                style={{
                  textAlign: "center",
                  display: "block",
                  marginTop: "20px",
                  marginBottom: "20px",
                }}
              />
            }
            // endMessage={
            //   <h2 style={{ textAlign: "center" }}>
            //     <b>You have seen it all</b>
            //   </h2>
            // }
          > */}
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                <TableCell sx={{ width: "75px" }}>Photo </TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Document Type</TableCell>
                <TableCell>Document Number</TableCell>
                <TableCell>Country</TableCell>
                <TableCell>Created At </TableCell>

                <TableCell align="right">View</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {!userLoading &&
                userList.length > 0 &&
                userList.map((row, i) => (
                  <TableRow
                  // sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell>
                      <Avatar
                        src={
                          row.selfie_image?.selfie_image_link
                            ? row.selfie_image?.selfie_image_link
                            : row.user_image?.user_image_link
                        }
                      />
                    </TableCell>
                    <TableCell
                      sx={{
                        color: `${theme.palette.primary.main}`,
                        fontWeight: 500,
                      }}
                    >
                      {row.name}
                    </TableCell>
                    {showStatusText(row)}
                    {/* {row.selfie_image?.selfie_image_link && (
                      <TableCell
                        sx={{
                          color: `${theme.palette.success.main}`,
                          fontWeight: 500,
                        }}
                      >
                        Complete
                      </TableCell>
                    )}
                    {row.fail_photo_matching?.length === 5 && (
                      <TableCell
                        sx={{
                          color: `${theme.palette.success.main}`,
                          fontWeight: 500,
                        }}
                      >
                        Not Verified
                      </TableCell>
                    )}
                    {row.selfie_image?.selfie_image_link === undefined ? (
                      row?.fail_photo_matching === undefined ? ""
                    ) : (
                      <TableCell
                        sx={{
                          color: `${theme.palette.success.main}`,
                          fontWeight: 500,
                        }}
                      >
                        Partially Verified
                      </TableCell>
                    )} */}

                    {/* {row.selfie_image?.selfie_image_link ? (
                      <TableCell
                        sx={{
                          color: `${theme.palette.success.main}`,
                          fontWeight: 500,
                        }}
                      >
                        Complete
                      </TableCell>
                    ) : (
                      <TableCell
                        sx={{
                          color: `${theme.palette.info.main}`,
                          fontWeight: 500,
                        }}
                      >
                        Partially Complete
                      </TableCell>
                    )} */}

                    <TableCell>{row.idType}</TableCell>
                    <TableCell>
                      {row.id && row.id}
                      {row.passportNo && row.passportNo}
                    </TableCell>
                    <TableCell>{row.countryName}</TableCell>

                    <TableCell
                      sx={{
                        color: `${theme.palette.text.light}`,
                      }}
                    >
                      {moment(row.created_at).format("DD MMM YYYY")}
                    </TableCell>

                    <TableCell align="right">
                      <IconButton
                        // component={Link}
                        // to={`/user-details/${row._id}`}
                        onClick={() => handleClickOpen(row._id)}
                      >
                        <VisibilityOutlinedIcon
                          color={theme.palette.text.light}
                        />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              {!userLoading && userList.length < 1 ? (
                <TableRow>
                  <TableCell colSpan={8} style={{ textAlign: "center" }}>
                    No data found
                    {/* {userMessage.length > 0 ? userMessage : "No data found"}{" "} */}
                  </TableCell>
                </TableRow>
              ) : null}
              {userLoading && pageLoading()}
            </TableBody>
          </Table>
          {/* </InfiniteScroll> */}
        </TableContainer>
        {userList.length > 0 && (
          // <TablePagination
          //   component="div"
          //   count={100}
          //   page={page}
          //   onPageChange={handleChangePage}
          //   rowsPerPage={rowsPerPage}
          //   onRowsPerPageChange={handleChangeRowsPerPage}
          // />
          <TablePagination
            style={{ display: "block", borderBottom: "none" }}
            rowsPerPageOptions={[]}
            // count={rows.length}
            count={totalData}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        )}
      </Paper>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="xl"
      >
        <DialogTitle id="alert-dialog-title" sx={{ textAlign: "right", mb: 2 }}>
          <IconButton
            variant="outlined"
            disableElevation
            onClick={handleClose}
            style={{ background: theme.palette.border.main }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {/* <Box sx={{ textAlign: "right", mb: 2 }}>
            <IconButton
              variant="outlined"
              disableElevation
              onClick={handleClose}
              style={{ background: theme.palette.border.main }}
            >
              <CloseIcon />
            </IconButton>
          </Box> */}
          <UserDetails id={userId} />
        </DialogContent>
        {/* <DialogActions>
          <Button
            variant="outlined"
            disableElevation
            autoFocus
            startIcon={<CloseIcon fontSize="small" />}
            onClick={handleClose}
            sx={{ minWidth: "160px" }}
          >
            Close  
          </Button>
        </DialogActions> */}
      </Dialog>
        </>
      )}
    </div>
  );
};

export default UserList;
